import { useMutation } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { isEqual } from 'lodash-es';
import { submitScoreCard } from './api';

export const useScorecardAutoSaveHelper = ({
  atsApplicationId,
  scorecardId,
  questions = [],
}) => {
  const previousValuesRef = useRef({});
  const submitScoreCardMutation = useMutation({
    mutationFn: (payload) => submitScoreCard(payload),
  });
  const [isSaved, setIsSaved] = useState(null);

  const handleAutoSave = async (values) => {
    const currentValues = {
      rating: values.rating,
      feedback: values.feedback,
      ...values,
    };

    // Descriptions are display-only copy, not answers — drop them.
    const {
      feedback_description: _feedbackDescription,
      rating_description: _ratingDescription,
      ...currentValuesRest
    } = currentValues;

    const hasChanges = !isEqual(currentValuesRest, previousValuesRef.current);

    // Attachment keys are always arrays, so an empty scorecard looked filled (ENG-3754).
    const hasValue = Object.values(currentValuesRest).some((value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== '' && value !== null && value !== undefined;
    });

    if (!hasChanges || !hasValue) return;

    const payload = {
      rating: currentValuesRest.rating,
      feedback: currentValuesRest.feedback,
      questions: questions?.map((item, idx) => {
        const param = { question: item?.question };
        if (values?.[idx + 1]) param.answer = values?.[idx + 1];
        return param;
      }),
      status: 'draft',
    };

    setIsSaved('isLoading');

    try {
      await submitScoreCardMutation.mutateAsync({
        applicationId: atsApplicationId,
        scorecardId: scorecardId,
        payload,
      });
      previousValuesRef.current = currentValuesRest;
      setIsSaved('success');
    } catch {
      setIsSaved('error');
    }
  };

  return { handleAutoSave, isSaved };
};
